import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import {
  actionGetTickets,
  actionDeleteTicket,
  actionTransferTicket,
} from "../../actions/EventActions";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { actionGetUsersByEmailOrDU } from "../../actions/UserActions";
import moment from "moment";
import {
  LOGIN_ROUTE,
  TICKET_ADD_ROUTE,
  TICKET_EDIT_ROUTE,
} from "../../config/RoutesConstants";
import {
  Container,
  IconButton,
  Badge,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Paper,
  Typography,
  Fab,
  Toolbar,
  TableSortLabel,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Tooltip,
  Chip,
  Input,
  TextField,
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Sync";
import { withTheme } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/ArrowBackRounded";
import AddIcon from "@material-ui/icons/Add";
import ColorIcon from "@material-ui/icons/FiberManualRecord";
import Util, { ERROR, WARNING, SUCCESS } from "../../common/Util";
import { ORIGIN } from "../../common/Constants";
import { typeInteger, validateEmail } from "../../common/Validations";

class Tickets extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowPerPage: 5,
      count: 0,
      tickets: [],
      filter: "",
      ticketForDelete: false,
      orderBy: "tktBuyDate",
      orderDesc: true,
      ticketForTransfer: false,
      userDialogInformation: false,
      userDialogInformationUser: {},
      dniTransfer: "",
      searchField: "E-mail",
      search: "",
      emailError: "",
    };
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.getDeleteTicketSuccess = this.getDeleteTicketSuccess.bind(this);
    this.getTransferTicketError = this.getTransferTicketError.bind(this);
    this.getTransferTicketSuccess = this.getTransferTicketSuccess.bind(this);
    this.onAddTicket = this.onAddTicket.bind(this);
    this.onConfirmDeleteTicket = this.onConfirmDeleteTicket.bind(this);
    this.transferTicket = this.transferTicket.bind(this);
    this.onTransferTicket = this.onTransferTicket.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.filterTickets = this.filterTickets.bind(this);
    this.onChangeDniTransfer = this.onChangeDniTransfer.bind(this);
    this.onSearchUser = this.onSearchUser.bind(this);
    this.sortTickets = this.sortTickets.bind(this);
  }

  componentWillMount() {
    if (!this.props.login) {
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.onChangePage(null, this.state.page);
  }

  getTicketsError(e) {
    console.log("ERROR AL LISTAR TICKETS", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tickets.");
  }

  onRefresh() {
    this.onChangePage(null, this.state.page);
  }

  onSearch(evt) {
    this.setState(
      { search: evt.target.value, errorEmail: "" },
      this.onChangePage
    );
  }

  filterTickets(ticket) {
    let filter = new RegExp(this.state.search, "ig");
    let result =
      (ticket.tktDisplayName && ticket.tktDisplayName.match(filter)) ||
      (ticket.tktCategory && ticket.tktCategory.match(filter)) ||
      (ticket.tktBuyerDU && ticket.tktBuyerDU.match(filter)) ||
      (ticket.tktBuyerName && ticket.tktBuyerName.match(filter)) ||
      (ticket.tktOwnerDU && ticket.tktOwnerDU.match(filter)) ||
      (ticket.tktOwnerName && ticket.tktOwnerName.match(filter)) ||
      (ticket.tktRrpp && ticket.tktRrpp.match(filter)) ||
      // (ticket.tktPrice && ticket.tktPrice.match(filter)) ||
      // (ticket.tktBuyDate && ticket.tktBuyDate.match(filter)) ||
      (ticket.tktBuyOperationId && ticket.tktBuyOperationId.match(filter)) ||
      (ticket.tktState && ticket.tktState.match(filter)) ||
      (ticket.tktColor && ticket.tktColor.match(filter)) ||
      (ticket.createName && ticket.createName.match(filter)) ||
      (ticket.createLastName &&
        ticket.tktDisplayNamecreateLastName.match(filter));
    if (
      result &&
      this.state.birthdateFrom &&
      this.state.birthdateTo &&
      this.state.birthmonth != -1
    ) {
      let b = this.toMoment(ticket.proBirthDate);
      result =
        b instanceof moment &&
        b.month() == this.state.birthmonth &&
        b.date() >= this.state.birthdateFrom &&
        b.date() <= this.state.birthdateTo;
    }
    // let tagFilter = this.state.tagsFilterSelected;
    // if (result && tagFilter && tagFilter.length > 0) {
    //   result =
    //     ticket.proTags &&
    //     tagFilter.some((t) => ticket.proTags.some((ut) => ut.id == t.id));
    // }
    return result;
  }

  onChangePage(dta, newPage = 0) {
    console.log("this.props.event.id", this.props.event.id);
    this.props.actionGetTickets(
      { evtId: this.props.event.id, search: this.state.search },
      { field: this.state.orderBy, desc: this.state.orderDesc },
      { from: newPage * this.state.rowPerPage, size: this.state.rowPerPage },
      () => {
        this.setState({
          page: newPage,
        });
      },
      this.getTicketsError
    );
  }

  onChangeRowsPerPage(evt) {
    this.setState(
      {
        rowPerPage: evt.target.value,
      },
      this.onChangePage
    );
  }

  onSortByField(field) {
    if (field == this.state.orderBy) {
      this.setState({ orderDesc: !this.state.orderDesc }, this.onChangePage);
    } else {
      this.setState({ orderBy: field }, this.onChangePage);
    }
  }

  sortTickets(a, b) {
    try {
      if (!this.state.orderDesc) {
        switch (this.state.orderBy) {
          case "tktBuyerName":
            return `${a[this.state.orderBy]} ${
              a["tktBuyerName"]
            }`.localeCompare(`${b[this.state.orderBy]} ${b["tktBuyerName"]}`);
          case "tktDisplayName":
            return `${a[this.state.orderBy]} ${
              a["tktDisplayName"]
            }`.localeCompare(`${b[this.state.orderBy]} ${b["tktDisplayName"]}`);
          case "tktOwnerName":
            return `${a[this.state.orderBy]} ${
              a["tktOwnerName"]
            }`.localeCompare(`${b[this.state.orderBy]} ${b["tktOwnerName"]}`);
          case "tktState":
            return `${a[this.state.orderBy]} ${a["tktColor"]}`.localeCompare(
              `${b[this.state.orderBy]} ${b["tktState"]}`
            );
          case "tktRrpp":
            return a[this.state.orderBy] < b[this.state.orderBy] ? 1 : -1;
          case "createEmail":
            return `${a[this.state.orderBy]} ${a["createEmail"]}`.localeCompare(
              `${b[this.state.orderBy]} ${b["createEmail"]}`
            );
          case "tktBuyDate":
            return moment.unix(a.tktBuyDate).isBefore(moment.unix(b.tktBuyDate))
              ? 1
              : -1;
          default:
            break;
        }
      } else {
        switch (this.state.orderBy) {
          case "tktBuyerName":
            return `${b[this.state.orderBy]} ${
              b["tktBuyerName"]
            }`.localeCompare(`${a[this.state.orderBy]} ${a["tktBuyerName"]}`);
          case "tktDisplayName":
            return `${b[this.state.orderBy]} ${
              b["tktDisplayName"]
            }`.localeCompare(`${a[this.state.orderBy]} ${a["tktDisplayName"]}`);
          case "tktOwnerName":
            return `${b[this.state.orderBy]} ${
              b["tktOwnerName"]
            }`.localeCompare(`${a[this.state.orderBy]} ${a["tktOwnerName"]}`);
          case "createEmail":
            return `${b[this.state.orderBy]} ${b["createEmail"]}`.localeCompare(
              `${a[this.state.orderBy]} ${a["createEmail"]}`
            );
          case "tktState":
            return `${b[this.state.orderBy]} ${b["tktState"]}`.localeCompare(
              `${a[this.state.orderBy]} ${a["tktState"]}`
            );
          case "tktRrpp":
            return a[this.state.orderBy] < b[this.state.orderBy] ? -1 : 1;
          case "tktBuyDate":
            return moment.unix(a.tktBuyDate).isBefore(moment.unix(b.tktBuyDate))
              ? -1
              : 1;
          default:
            break;
        }
      }
    } catch (e) {
      console.log("SORT ERROR", e);
      return -1;
    }
  }
  onChangeDniTransfer(evt) {
    this.setState({ dniTransfer: evt.target.value, dniError: "" });
  }

  onAddTicket() {
    this.props.history.push(TICKET_ADD_ROUTE);
  }

  onEditTicket(ticket) {
    this.props.history.push(TICKET_EDIT_ROUTE, ticket);
  }

  onConfirmDeleteTicket() {
    const { id, tktOwnerDU, tktState } = this.state.ticketForDelete;
    this.props.actionDeleteTicket(
      id,
      tktOwnerDU,
      tktState,
      this.getDeleteTicketSuccess,
      this.getDeleteTicketError
    );
    this.setState({ ticketForDelete: false });
  }

  transferTicket() {
    const { dniTransfer: receiverDocument, ticketForTransfer } = this.state;
    const { event } = this.props;
    const { id: eventId } = event;
    const { id: ticketId, tktOwnerDU: senderDocument } = ticketForTransfer;
    if (!receiverDocument) {
      this.setState({ dniError: "Debe completar el campo" });
    } else {
      this.props.actionTransferTicket(
        { receiverDocument, senderDocument, eventId, ticketId },
        this.getTransferTicketSuccess,
        this.getTransferTicketError
      );
      this.setState({ ticketForTransfer: false, dniTransfer: "" });
    }
  }

  onDeleteTicket(ticket) {
    this.setState({ ticketForDelete: ticket });
  }
  onTransferTicket(ticket) {
    this.setState({ ticketForTransfer: ticket });
  }

  getDeleteTicketSuccess() {
    const event = this.props.event;
    this.onChangePage(null, this.state.page);
  }

  getDeleteTicketError(e) {
    console.log("ERROR GET DELETE TICKET", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el ticket.");
  }
  getTransferTicketSuccess(){
    Util.showNoty(SUCCESS, "El ticket se transfirio con exito.");
    this.onChangePage(null, this.state.page);
  }
  getTransferTicketError(e) {
    const { body = {} } = e;
    const { error = "" } = body;
    console.log("getTransferTicketError", error);
    if (error === "Destination user doesnt exist") {
      Util.showNoty(ERROR, "El dni destino no existe.");
    } else {
      Util.showNoty(ERROR, "Ocurrió un error al transferir el ticket.");
    }
    this.setState({ ticketForTransfer: false, dniTransfer: "" });
  }

  renderTableHeader() {
    const { theme } = this.props;

    const headers = [
      { id: "tktDisplayName", label: "Nombre", hasFilter: true },
      { id: "tktCategory", label: "Categoría" },
      { id: "tktBuyerDU", label: "DNI Comprador" },
      { id: "tktBuyerName", label: "Comprador", hasFilter: true },
      { id: "tktOwnerDU", label: "DNI Poseedor" },
      { id: "tktOwnerName", label: "Poseedor", hasFilter: true },
      { id: "tktRrpp", label: "RRPP", hasFilter: true },
      { id: "tktPrice", label: "Precio" },
      { id: "tktBuyDate", label: "Fecha de compra", hasFilter: true },
      { id: "tktBuyOperationId", label: "Id de Operación" },
      { id: "tktState", label: "Status", hasFilter: true },
      { id: "tktColor", label: "Color" },
      { id: "createEmail", label: "Creado por", hasFilter: true },
    ];
    return (
      <TableRow>
        {headers.map((label) => {
          return (
            <TableCell>
              {label.hasFilter ? (
                <TableSortLabel
                  active={this.state.orderBy === label.id}
                  direction={
                    this.state.orderBy === label.id && this.state.orderDesc
                      ? "desc"
                      : "asc"
                  }
                  onClick={() => this.onSortByField(label.id)}
                  hideSortIcon={false}
                >
                  {label.label}
                </TableSortLabel>
              ) : (
                label.label
              )}
            </TableCell>
          );
        })}
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }

  isValidSearch() {
    let isValid = true;
    if (this.state.search) {
      switch (this.state.searchField) {
        case "E-mail": //Emails
          let errorEmail = validateEmail(this.state.search);
          if (errorEmail) {
            this.setState({ emailError: errorEmail });
            isValid = false;
          }
          break;
        case "DU": //DU
          if (!/^[0-9]{1,3}(\.?[0-9]{3})*$/.test(this.state.search)) {
            // console.log("TEST", !(/[0-9]{3}(\.?[0-9]{3})*/).test(this.state.search))
            let errorDU = "Este campo solo admite números enteros."; //typeInteger(this.state.search)
            // if(errorDU){
            this.setState({ emailError: errorDU });
            isValid = false;
            // }
          }
          break;
        case "IdOperacion": // IdOperacion //TODO Validar Id Operación no es numérico
          let errorIdOperacion = typeInteger(this.state.search);
          if (errorIdOperacion) {
            this.setState({ emailError: errorIdOperacion });
            isValid = false;
          }
          break;
        default:
          break;
      }
    }
    return isValid;
  }

  onSearchUser() {
    this.setState({ emailError: "" });
    if (this.isValidSearch()) {
      this.setState({ filter: this.state.search }, this.onChangePage);
    }
  }
  onPressUserInformation(item, buyerDialog) {
    const { tktBuyerDU, tktBuyerEmail, tktOwnerDU, tktOwnerEmail } = item;
    this.props.actionGetUsersByEmailOrDU(
      buyerDialog ? tktBuyerDU : tktOwnerDU,
      buyerDialog ? tktBuyerEmail : tktOwnerEmail,
      (data) => {
        if (data && data.users && data.users.length > 0) {
          this.setState({
            userDialogInformation: true,
            userDialogInformationUser: data.users[0],
          });
        } else {
          Util.showNoty(WARNING, "No encontramos el usuario");
        }
      },
      (e) => {
        Util.showNoty(ERROR, "No se encontró el usuario.");
      }
    );
  }
  renderTableBody() {
    const { theme } = this.props;
    let tickets = this.props.ticketList.items;
    console.log("TICKETS", tickets);
    if (!tickets || tickets.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return tickets.map((item, index) => {
      console.log("******* ITEM", item);
      let isActive = item.tktState;
      let stateLabel;
      switch (item.tktState) {
        case "pendingUse":
          stateLabel = "Pendiente";
          break;
        case "already_used":
          stateLabel = "Utilizado";
          break;
        case "pendingCreate":
          stateLabel = "Sin Generar";
          break;
        default:
          stateLabel = "";
      }
      let buyDate = item.tktBuyDate || item.tktInviteDate;
      let itemCountTooltip = null;
      if (item.ticketCount) {
        itemCountTooltip =
          item.ticketCount > 1
            ? `${item.ticketCount} invitaciones`
            : `${item.ticketCount} invitación`;
      }
      let origin = {};
      switch (item.tktOrigin) {
        case ORIGIN.standard:
          origin.label = item.rrppName ? "R" : "";
          origin.tooltip = item.rrppName ? "Referenciada" : "";
          origin.color = item.rrppName ? "#777777" : "transparent";
          break;
        case ORIGIN.rrppSell:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.producer:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.producerBO:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.gift:
          origin.label = "I";
          origin.tooltip = "Invitación";
          origin.color = "orange";
          break;
        case ORIGIN.loyaly:
          origin.label = "C";
          origin.tooltip = "Canje";
          origin.color = "#B0A80D";
          break;
        default:
          origin.label = "";
          origin.tooltip = "";
          origin.color = "transparent";
          break;
      }
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <TableCell>
            <Tooltip title={itemCountTooltip} placement="left-start">
              <Badge color="primary" badgeContent={item.ticketCount}>
                <Typography>{item.tktDisplayName}</Typography>
              </Badge>
            </Tooltip>
          </TableCell>
          <TableCell>{item.tktCategory}</TableCell>
          <TableCell>
            <Tooltip title={item.tktBuyerEmail}>
              <Typography variant="body">{item.tktBuyerDU}</Typography>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title={item.tktBuyerEmail}>
              <Button
                style={{ backgroundColor: "aquamarine" }}
                onClick={() => this.onPressUserInformation(item, true)}
              >
                <Typography variant="body">{item.tktBuyerName}</Typography>
              </Button>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title={item.tktOwnerEmail}>
              <Typography variant="body">
                {item.tktOwnerDU || item.proDNI}
              </Typography>
            </Tooltip>
          </TableCell>
          <TableCell>
            <Tooltip title={item.tktOwnerEmail}>
              <Button
                style={{ backgroundColor: "aquamarine" }}
                onClick={() => this.onPressUserInformation(item, false)}
              >
                <Typography variant="body">
                  {item.tktOwnerName || item.proEmail}
                </Typography>
              </Button>
            </Tooltip>
          </TableCell>
          <TableCell>
            {/* {item.tktRrppName&& */}
            <div style={{ display: "flex" }}>
              <Typography variant="body">{item.rrppName}</Typography>
              <Tooltip title={origin.tooltip}>
                <Typography
                  variant="body"
                  style={{
                    backgroundColor: origin.color,
                    color: "white",
                    borderRadius: 90,
                    borderStyle: "solid",
                    borderWidth: 1,
                    width: 20,
                    height: 20,
                    textAlign: "center",
                    marginLeft: 6,
                    paddingTop: 1,
                  }}
                >
                  {origin.label}
                </Typography>
              </Tooltip>
            </div>
            {/* } */}
          </TableCell>
          <TableCell>{Util.formatCurrency(item.tktPrice)}</TableCell>
          <TableCell>
            {Util.formatDateToShow(Util.timestampToMoment(buyDate))}
          </TableCell>
          <TableCell>{item.tktBuyOperationId}</TableCell>
          <TableCell
            style={
              isActive
                ? theme.table.activeCell
                : theme.overrides.MuiTableCell.body
            }
          >
            {stateLabel}
          </TableCell>
          <TableCell>
            <ColorIcon style={{ color: item.tktColor }} />
          </TableCell>
          <TableCell>
            <Tooltip title={item.createEmail}>
              <Typography variant="body">
                {item.createName} {item.createLastName}
              </Typography>
            </Tooltip>
          </TableCell>
          {/* <TableCell>{item.tktLastUpdateUser}</TableCell> */}
          <TableCell style={{ ...theme.table.actionsColumn, minWith: 200 }}>
            {/* <Tooltip title="Editar ticket">
              <IconButton onClick={this.onEditTicket.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip> */}
            {item.tktState != "already_used" && (
              <div>
                <Tooltip title="Eliminar ticket">
                  <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                {item.tktState != "pendingCreate" && (
                  <Tooltip title="Transferir ticket">
                    <IconButton
                      onClick={this.onTransferTicket.bind(this, item)}
                    >
                      <ConfirmationNumberIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            )}
          </TableCell>
        </TableRow>
      );
    });
  }
  renderDialogTransferTicket() {
    return (
      <Dialog open={this.state.ticketForTransfer}>
        <DialogTitle>Transferir el ticket</DialogTitle>
        <DialogContent>
          <FormControl error={this.state.dniError ? true : false}>
            <Input
              placeholder="Ingresá el DNI destino"
              shrink
              onChange={this.onChangeDniTransfer}
              value={this.state.dniTransfer}
              helperText={this.state.dniError}
            />
            <FormHelperText>{this.state.dniError}</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancelar">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                this.setState({ ticketForTransfer: null, dniTransfer: "" });
              }}
            >
              Cancelar
            </Button>
          </Tooltip>
          <Tooltip title="Transferir ticket">
            <Button
              variant="contained"
              color="primary"
              onClick={this.transferTicket}
            >
              Transferir
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    );
  }
  openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  renderPopUpUserInformation() {
    const { userDialogInformationUser } = this.state;
    const {
      proTags = [],
      proInstagram = "",
      proDNI = "",
      proName = "",
      proEmail = "",
      proLastName = "",
      proPhone = "",
    } = userDialogInformationUser;
    return (
      <Dialog
        maxWidth={"xl"}
        fullWidth={true}
        open={this.state.userDialogInformation}
      >
        <DialogTitle>Informacion del Usuario</DialogTitle>
        <DialogContent>
          <Table
            stickyHeader
            style={{
              minWidth: 500,
              boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.23)",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Nombre
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Apellido
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Instagram
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Telefono
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Email
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Documento
                </TableCell>
                <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                  Tags
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{proName}</TableCell>
                <TableCell>{proLastName}</TableCell>
                <TableCell>
                  <Button
                    style={{ backgroundColor: "aquamarine" }}
                    onClick={() =>
                      this.openInNewTab(`https://instagram.com/${proInstagram}`)
                    }
                  >
                    {proInstagram}
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    style={{ backgroundColor: "aquamarine" }}
                    onClick={() =>
                      this.openInNewTab(
                        `https://api.whatsapp.com/send/?phone=549${proPhone}`
                      )
                    }
                  >
                    {proPhone}
                  </Button>
                </TableCell>
                <TableCell>{proEmail}</TableCell>
                <TableCell>{proDNI}</TableCell>
                <TableCell>
                  {proTags.map((t) => (
                    <Chip
                      label={t.tagName}
                      style={{ backgroundColor: t.tagColor }}
                    />
                  ))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Aceptar">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                this.setState({
                  userDialogInformation: null,
                  userDialogInformationUser: {},
                });
              }}
            >
              Aceptar
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    );
  }
  render() {
    const { theme, event } = this.props;
    return (
      <Box style={theme.mainContainer}>
        <Box
          style={{
            ...theme.title.container,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <Box style={theme.title.backIconContainer}>
            <IconButton
              onClick={this.props.history.goBack}
              style={theme.title.backIcon}
            >
              <BackIcon
                style={{ fontSize: "2.5rem" }}
                stroke="white"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{event.evtName}</Typography>
            <Typography variant="subtitle1">
              Crea tickets para el evento seleccionado
            </Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>
          <Paper>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Typography style={theme.paper.title} variant="h2">
                Listado de Tickets
              </Typography>
              <Fab
                onClick={this.onRefresh}
                size="small"
                style={{ marginLeft: 16, width: 34, height: 34 }}
                color="secondary"
              >
                <RefreshIcon style={{ fontSize: 20 }} />
              </Fab>
            </Box>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nuevo ticket">
                <Fab color="primary" onClick={this.onAddTicket} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Box style={{ width: 250, paddingLeft: 10, paddingRight: 10 }}>
                  <TextField placeholder="Buscar" onChange={this.onSearch} />
                </Box>
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead>{this.renderTableHeader()}</TableHead>
              <TableBody>{this.renderTableBody()}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.props.ticketList.size}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.ticketForDelete}>
            <DialogTitle>Eliminar Ticket</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el ticket?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ ticketForDelete: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar ticket">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmDeleteTicket}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          {this.renderDialogTransferTicket()}
          {this.renderPopUpUserInformation()}
        </Container>
      </Box>
    );
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    ticketList: store.evt.ticketList,
    event: store.evt.event,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTickets,
      actionDeleteTicket,
      actionTransferTicket,
      actionGetUsersByEmailOrDU,
    },
    dispatch
  );
}

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(Tickets))
);



// WEBPACK FOOTER //
// ./src/screens/events/Tickets.js